export enum AppointmentStatusCodes {
   REBOOK_PENDING = "RP",
   IMPACTED_APPOINTMENT = "IA",
   NO_SHOW = "NS",
   PRESENTED = "P",
   SCHEDULED = "S",
   CANCELLED = "X",
}
